import { render, staticRenderFns } from "./Invoices_nc.vue?vue&type=template&id=60e48852"
import script from "./Invoices_nc.vue?vue&type=script&lang=js"
export * from "./Invoices_nc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports